import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        [theme.breakpoints.up('md')]: {
          display: 'flex !important',
          flex: 'auto',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        },
      },
      header: {
        width: '100%',
        padding: theme.spacing(1, 0),
      },
      content: {
        flex: 'auto',
        width: '100%',
      },
    }),
  { name: 'PrivateContainer' }
);
